import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
import { Action, Getter, State, Mutation } from 'vuex-class'
import Modal from '@/components/modalBase/modalBase'

@Component({
  components: {
    Modal
  }
})
export default class CommerceAlertCart extends Vue {
  @Prop({ default: false }) show!: Boolean
}
